import { IFaq } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class StepService extends AxiosService {
  private static instance: StepService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): StepService {
    if (!StepService.instance) {
      StepService.instance = new StepService();
    }
    return StepService.instance;
  }

  public async findAllWithForm(optionId: string): Promise<any> {
    try {
      const url: string = 'step/findAllWithform';
      const response: IFaq[] = await this.axios.post(url, { status: true, optionId });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default StepService.getInstance;
